import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '默认页',
    component:()=>import('@/components/Root.vue')
  },
  {
    path: '/login',
    name: '登录',
    component:()=>import('@/views/login.vue')
  },
  {
    path: '/textFieldDialog',
    name: '文本领域',
    component:()=>import('@/views/textFieldDialog.vue')
  },
  {
    path: '/pie',
    name: '饼状图',
    component:()=>import('@/views/pie.vue')
  },
  {
    path: '/thesaurus',
    name: '正词库',
    component:()=>import('@/views/thesaurus/index.vue')
  },
  {
    path: '/wrongThesaurus',
    name: '错词库',
    component:()=>import('@/views/wrongThesaurus/index.vue')
  },
  {
    path: '/monitor',
    name: '重点监控',
    component:()=>import('@/views/monitor/index.vue')
  },
  {
    path: '/markingStyle',
    name: '标记方式',
    component:()=>import('@/views/markingStyle/index.vue')
  },
  {
    path: '/errata',
    name: '勘误表',
    component:()=>import('@/views/errata/index.vue')
  },
  {
    path: '/dictionary',
    name: '辞书查词',
    component:()=>import('@/views/dictionary/index.vue')
  },
  {
    path: '/textProofreading',
    name: '通篇校对',
    component:()=>import('@/views/textProofreading/index.vue')
  },
  {
    path: '/currentParagraph',
    name: '当前段落',
    component:()=>import('@/views/currentParagraph/index.vue')
  },
  {
    path: '/updateAdvice',
    name: '修改建议',
    component:()=>import('@/views/updateAdvice/index.vue')
  }
]


const router = new VueRouter({
  routes,
});

export default router;
